import { Tooltip, Typography } from "@mui/material";
import InfoIcon from "@Washouts/assets/icons/info-grey.svg";

const renderTitle = (titleProps, titleLabel) => {
	return (
		<Typography {...titleProps}>
			<span style={{ display: "inline-flex", alignItems: "flex-start", gap: "5px", whiteSpace: "nowrap" }}>
				{titleLabel}
				{titleProps?.icon?.present && (
					<Tooltip title={titleProps?.icon?.text ?? ""} placement={"top"} arrow sx={{ fontFamily: "PT Sans Narrow" }}>
						<img src={InfoIcon} alt="info" height="10px" width="10px" style={{ marginTop: "2px", flexShrink: 0 }} />
					</Tooltip>
				)}
			</span>
		</Typography>
	);
};

export { renderTitle };
